var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9200",
    "data-name": "Rectangle 9200",
    width: 2.072,
    height: 10.786,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22514",
    "data-name": "Group 22514",
    transform: "translate(-1032.824 -546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22513",
    "data-name": "Group 22513",
    transform: "translate(178.074 -96.75)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    cx: 7.75,
    cy: 7.75,
    r: 7.75,
    transform: "translate(856 644)",
    fill: "#ea4e3d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17218",
    "data-name": "Group 17218",
    transform: "translate(863 646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17217",
    "data-name": "Group 17217",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15743",
    "data-name": "Path 15743",
    d: "M2.494,6.652a.966.966,0,0,1-.346.786.937.937,0,0,1-1.04.15.917.917,0,0,1-.581-.874c-.008-.949,0-1.9,0-2.848h0q0-1.413,0-2.826A.974.974,0,0,1,.983.156a.976.976,0,0,1,1.5.821c.016,1.157.005,2.314.006,3.471,0,.734,0,1.469,0,2.2",
    transform: "translate(-0.472 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15744",
    "data-name": "Path 15744",
    d: "M1.03,97.664A1.041,1.041,0,1,1,0,98.7,1.043,1.043,0,0,1,1.03,97.664",
    transform: "translate(-0.001 -88.96)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "\\u4E0B\\u8F7D_2_",
    "data-name": "\\u4E0B\\u8F7D (2)",
    width: 18,
    height: 18,
    rx: 8,
    transform: "translate(1032.824 546)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.5828f337b1593945f2352ba755efb1f5.svg";
export { ForwardRef as ReactComponent };